import React from 'react';
import Dropzone, { DropzoneOptions } from 'react-dropzone-latest';

interface DropzoneStateProps {
  children?: React.ReactNode;
  dropzoneWrapperClass?: string;
}

/**
 * @deprecated Use `FileDropzone` from `src/components/FileDropzone` instead.
 * This legacy copy will be removed once all callers have migrated.
 */
export const FileDropzone: React.FC<DropzoneOptions & DropzoneStateProps> = (
  props,
) => {
  const { children, dropzoneWrapperClass, ...rest } = props;
  return (
    <Dropzone {...rest}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={dropzoneWrapperClass}>
          <input {...getInputProps()} />
          {children}
        </div>
      )}
    </Dropzone>
  );
};
